var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alertDiscountProcess"},[_c('img',{staticClass:"alertDiscountProcess__ico",attrs:{"src":require("assets/img/failure-mark.svg")}}),_vm._v(" "),_c('p',{staticClass:"alertDiscountProcess__text"},[_vm._v("\n    Скидка уже применяется\n  ")])])
}]

export { render, staticRenderFns }